module.exports = __webpack_public_path__ + "img/koniec.a7bb902c.webp";